import axios from "axios";
import { AppConfig } from "../../shared/utilities/AppConfig";
import { OrganizationProfilesResponse } from "../../shared/definitions/internationalTypes";

export type GetOrganizationProfilesParams = {
  page?: number;
};

export default async function getOrganizationProfiles(
  params: GetOrganizationProfilesParams = {},
) {
  const { data } = await axios.get<OrganizationProfilesResponse>(
    `${AppConfig.API_URL}/organisasi_internasional`,
    { params },
  );

  return data;
}
